import { Dispatch } from "redux";
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import jwtAxios from "../../@crema/services/auth/jwt-auth";
import { AppActions } from "types";
import { GET_TRANSATION } from "types/actions/transactionMaster.action";
  
export const getTransactionRecords = (search: string, offset: number) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get("payment-transactions/getTransaction/list")
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_TRANSATION, payload: response.data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
